module.exports = "<div id=\"preloader\" *ngIf=\"loading\">\r\n    <div class=\"inner\">\r\n        <img src=\"assets/images/loading.gif\" alt=\"loader\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component/loader/loader.component.html
// module id = ./src/app/shared/component/loader/loader.component.html
// module chunks = main